var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6561 19.999L27.5155 13.0146C27.6137 12.8985 27.5311 12.7222 27.3794 12.7222H25.5981C25.4932 12.7222 25.3928 12.769 25.3236 12.8494L20.491 18.6106L15.6584 12.8494C15.5914 12.769 15.491 12.7222 15.3838 12.7222H13.6026C13.4508 12.7222 13.3682 12.8985 13.4664 13.0146L19.3258 19.999L13.4664 26.9833C13.4444 27.0092 13.4303 27.0408 13.4257 27.0745C13.4212 27.1082 13.4264 27.1424 13.4407 27.1732C13.4551 27.204 13.4779 27.23 13.5066 27.2482C13.5353 27.2664 13.5686 27.2759 13.6026 27.2757H15.3838C15.4887 27.2757 15.5892 27.2289 15.6584 27.1485L20.491 21.3873L25.3236 27.1485C25.3905 27.2289 25.491 27.2757 25.5981 27.2757H27.3794C27.5311 27.2757 27.6137 27.0994 27.5155 26.9833L21.6561 19.999Z",
    fill: "#F5222D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cd5a4fb99bb0e30432c8346adf038662.svg";
export { ForwardRef as ReactComponent };